import { render, staticRenderFns } from "./Dropzone.vue?vue&type=template&id=4e6e22de&"
import script from "./Dropzone.vue?vue&type=script&lang=ts&"
export * from "./Dropzone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports